/* eslint-disable @wordpress/dependency-group */
import $ from 'jquery';

export default function() {

    let url = woocommerce_params.wc_ajax_url;
    url = url.replace(
        '%%endpoint%%',
        'get_refreshed_fragments'
    );

    $.post(url, function (data, status) {
        if (data.fragments) {
            jQuery.each(
                data.fragments,
                function (key, value) {
                    jQuery(key).replaceWith(value);
                }
            );
        }
        jQuery('body').trigger('wc_fragments_refreshed');
    });

}